import axios from 'axios'
import { ILoginResponse } from '../../../common/interfaces/auth.interface'
import { apiUrl } from '../../../config/api'
import { UserModel } from './_models'

const API_URL = process.env.REACT_APP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/verify_token`
export const LOGIN_URL = `/auth/backoffice/login`
export const REGISTER_URL = `${API_URL}/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/user/person/generate-code-recovery-password`
export const FORGOT_PASSWORD_URL = `/auth/backoffice/forgot-password`
export const IDENTITY_VALIDATION_URL = `${API_URL}/api/user/person/verify-account`
export const CHANGE_PASSWORD_URL = `/auth/backoffice/change-password`
export const VERIFY_CHANGE_PASSWORD_URL = `/auth/backoffice/verify-change-password`

interface IChangePasswordRequest {
  email: string
  new_password: string
  confirmation_password: string
  token: string
}

// Server should return AuthModel
export function login(email: string, password: string) {
  return apiUrl.post<ILoginResponse>(LOGIN_URL, {
    email,
    password,
  })
}

// Server should return AuthModel
export function register(
  email: string,
  fullname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    first_name: fullname,
    password,
    password_confirmation,
  })
}

export function requestPassword(email: string) {
  return apiUrl.post<{ result: boolean; message?: string }>(FORGOT_PASSWORD_URL, {
    email,
  })
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    api_token: token,
  })
}

export function verifyAccount(email: string, hash: string) {
  return axios.get(`${IDENTITY_VALIDATION_URL}/${email}/${hash}`)
}

export function verifyChangePasswordToken(email: string, token: string) {
  return apiUrl.post<{ valid: boolean; message?: string }>(VERIFY_CHANGE_PASSWORD_URL, {
    email,
    token,
  })
}

export function changePassword(data: IChangePasswordRequest) {
  return apiUrl.post(
    CHANGE_PASSWORD_URL,
    {
      email: data.email,
      token: data.token,
      new_password: data.new_password,
      confirmation_password: data.confirmation_password,
    }
    
  )
}
